import "./appLoader.css";
import spinner from "../assets/images/spinner.svg";
import { useSelector } from "react-redux";

const AppLoader = ({ showText = true }) => {
  const state = useSelector(({ notification: { loader } }) => ({ loader }));

  return state.loader ? (
    <div className="c-app-loader">
      <div className="c-loader">
        <img src={spinner} alt="loading" className="loader__spinner-img" />
        {showText && <h1>Loading ...</h1>}
      </div>
    </div>
  ) : null;
};

export default AppLoader;
